export enum CsatContactMode {
    add,
    edit
}